import { decodeSnapshotB64, emptySnapshot } from "./blocks.js";
import { WaveTemplateCatalog } from "./templates.js";
import { WaveBlockKind } from "./types.js";
import { WaveCloudAPI } from "./graphql/waveApi.js";
import { applyYDocUpdateB64, blocksFromYDoc, createWaveYDoc, isYjsWaveFormat, REMOTE_YJS_ORIGIN, } from "./yjs/waveYDoc.js";
import { expectedAppliedSeq } from "./waveSyncDiagnostics.js";
export function materializeBlocksFromYjsSnapshot(b64) {
    if (!b64)
        return [];
    const doc = createWaveYDoc();
    applyYDocUpdateB64(doc, b64, REMOTE_YJS_ORIGIN);
    return blocksFromYDoc(doc);
}
export function snapshotForLoad(wave) {
    const snap = decodeSnapshotB64(wave.latestSnapshotB64);
    if (snap && snap.blocks.length > 0)
        return snap;
    if (isYjsWaveFormat(wave.formatVersion) && wave.latestSnapshotB64) {
        const blocks = materializeBlocksFromYjsSnapshot(wave.latestSnapshotB64);
        if (blocks.length > 0)
            return { blocks, version: 1 };
    }
    if (wave.nextOpSeq === 0) {
        const template = WaveTemplateCatalog.find(wave.templateId);
        if (template)
            return { blocks: template.blocks, version: 1 };
    }
    return emptySnapshot();
}
/** @deprecated Prefer hydrateWaveDocument; kept for tests. */
export function looksLikePlaceholder(blocks, wave) {
    if (blocks.length === 0)
        return true;
    if (wave.nextOpSeq <= 0)
        return false;
    if (blocks.length === 1 &&
        blocks[0]?.kind === WaveBlockKind.Text &&
        !(blocks[0]?.payload?.text ?? "").trim()) {
        return true;
    }
    return false;
}
function applyBaselineAndOps(bridge, wave, tailOps) {
    const snapSeq = wave.latestSnapshotSeq ?? 0;
    bridge.prepareForLoad(snapSeq);
    bridge.loadSnapshotJSON(snapshotForLoad(wave));
    if (tailOps.length > 0) {
        bridge.applyRemoteOps(tailOps);
    }
}
/** Replay cloud snapshot + tail ops into the CRDT bridge when opening a wave. */
export async function hydrateWaveDocument(cfg, bridge, wave) {
    const snapSeq = wave.latestSnapshotSeq ?? 0;
    const tailOps = await WaveCloudAPI.listAllOps(cfg, wave.waveId, snapSeq);
    applyBaselineAndOps(bridge, wave, tailOps);
    const expected = expectedAppliedSeq(wave);
    if (wave.nextOpSeq > 0 && bridge.appliedSeq < expected) {
        const allOps = await WaveCloudAPI.listAllOps(cfg, wave.waveId, 0);
        const catchUp = allOps.filter((op) => op.seq > bridge.appliedSeq);
        if (catchUp.length > 0) {
            bridge.applyRemoteOps(catchUp);
        }
    }
    if (looksLikePlaceholder(bridge.blocks, wave) && wave.nextOpSeq > 0) {
        const allOps = await WaveCloudAPI.listAllOps(cfg, wave.waveId, 0);
        if (allOps.length > 0) {
            bridge.prepareForLoad(0);
            bridge.loadSnapshotJSON(emptySnapshot());
            bridge.applyRemoteOps(allOps);
        }
    }
}
